// extracted by mini-css-extract-plugin
module.exports = {"flex":"About_flex__15Z7V","container":"About_container__2-NrP","img":"About_img__Vu2yg","content":"About_content__2HhGZ","h1":"About_h1__2UAsS","desc":"About_desc__1I2J1"};